<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <div class="divider divider--gold mb-3"></div>

                    <h1 class="mb-5 font-h1 font-thin">
                        EDIT <span class="text-uppercase">{{ client.name }}</span>
                    </h1>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
<!--                            <label>-->
<!--                                Name-->
<!--                            </label>-->

                            <b-form-input
                                class="tb-form-field mb-3 font-h3"
                                placeholder="Name"
                                type="text"
                                v-model="form.name"
                                required>
                            </b-form-input>

<!--                            <label>-->
<!--                                User-->
<!--                            </label>-->

                            <custom-select
                                :options="user_options"
                                :defaultvalue="form.user_id"
                                :heading="'Select a user'"
                                @option-selected="(option) => form.user_id = option.value">
                            </custom-select>
                        </b-form-group>

                        <hr>

                        <b-form-group class="mt-0">
                            <b-row>
                                <b-col xs="12" md="6">
                                    <div class="border-wrapper mobile-100">
                                        <div class="border-wrapper__heading">
                                            <label>
                                                UPLOAD LOGO
                                            </label>
                                        </div>

                                        <simple-image-picker
                                            :src="form.logo"
                                            :width="200"
                                            :text="'choose logo'"
                                            :bg_color="form.header_color"
                                            @image-picked="(base64) => { form.logo_base64 = base64; }">
                                        </simple-image-picker>
                                    </div>
                                </b-col>

                                <b-col xs="12" md="6">
                                    <div class="border-wrapper border-wrapper--gold mt-5 mt-md-0 mobile-100">
                                        <div class="border-wrapper__heading">
                                            <label>
                                                COLOUR SCHEME
                                            </label>
                                        </div>

                                        <colour-picker class=""
                                                       :colour="form.header_color"
                                                       name="Primary colour"
                                                       @colour-picked="(new_color) => { form.header_color = new_color; }">
                                        </colour-picker>

                                        <colour-picker class="mt-3"
                                                       :colour="form.footer_color"
                                                       name="Accent colour"
                                                       @colour-picked="(new_color) => { form.footer_color = new_color; }">
                                        </colour-picker>
                                    </div>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <div class="border-wrapper mt-5 mt-md-5">
                                        <div class="border-wrapper__heading">
                                            <label>
                                                CUSTOM FIELDS
                                            </label>
                                        </div>

                                        <editable-custom-field-list
                                            :fields="client.custom_invite_fields"
                                            @changed="fields => { form.custom_invite_fields = fields; }">
                                        </editable-custom-field-list>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-button type="submit" variant="primary tb-button tb-button--blue font-h3 font-thin mt-4">
                            SUBMIT CLIENT
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    //import ImagePicker from '@/components/ImagePicker.vue';
    import SimpleImagePicker from '@/components/SimpleImagePicker.vue';
    import ColourPicker from '@/components/ColourPicker.vue';
    import clientRespository from "@/repository/clients";
    import userRepository from "@/repository/users";
    import EditableCustomFieldList from "@/components/EditableCustomFieldList.vue";
    import CustomSelect from "@/components/CustomSelect";

    export default {
        components: {
            //ImagePicker,
            SimpleImagePicker,
            ColourPicker,
            EditableCustomFieldList,
            CustomSelect
        },

        props: ['id'],

        data() {
            return {
                image_dimensions: {
                    height: 100,
                    width: 200
                },
                client: null,
                loaded: false,
                errors: {},
                users:[],
                form: {}
            }
        },

        mounted(){
            clientRespository.getById(
                this.id,
                {
                    include: 'user'
                })
                .then(response => {
                    //response.data.email = response.data.user.email;
                    this.client = response.data;
                    this.form = { ...this.client };
                    //this.loaded = true;
                    userRepository.getAll()
                        .then(response => {
                            this.users= response.data;
                            this.loaded = true;
                        });
                });

            
        },

        computed: {
            user_options(){
                return this.users.map((user)=>{
                    return {
                        value: user.id,
                        text: user.name
                    }
                })
            }
        },

        methods: {
            onSubmit() {
                clientRespository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Client Edited',
                            text: 'New client successfully edited.'
                        });
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });

                
            }
        }
    }
</script>

<style scoped lang="scss">

</style>